// Articles data for Conseils Carrière
export const careerArticles = [
  {
    id: 1,
    slug: 'promotion-janvier-actions-trimestre',
    title: 'Viser une promotion en janvier ? Voici 4 actions pour le dernier trimestre',
    excerpt: 'Le dernier trimestre est crucial pour préparer votre évolution de carrière. Découvrez les actions clés pour maximiser vos chances d\'obtenir une promotion.',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&h=450&fit=crop&crop=faces',
    category: 'Évolution de carrière',
    readTime: '5 min',
    date: '15 décembre 2025',
    author: 'Marie Dubois',
    authorRole: 'Consultante Senior',
    content: [
      {
        type: 'intro',
        text: 'Le dernier trimestre de l\'année est souvent décisif pour votre carrière. C\'est le moment où les entreprises planifient les budgets, les promotions et les augmentations pour l\'année à venir. Si vous visez une promotion en janvier, voici quatre actions concrètes à mettre en place dès maintenant.'
      },
      {
        type: 'heading',
        text: '1. Documentez vos réalisations'
      },
      {
        type: 'paragraph',
        text: 'Avant de demander une promotion, vous devez pouvoir démontrer votre valeur ajoutée. Prenez le temps de lister toutes vos réalisations de l\'année : projets menés à bien, objectifs dépassés, problèmes résolus, économies générées. Quantifiez autant que possible : "J\'ai augmenté les ventes de 15%" est plus percutant que "J\'ai amélioré les ventes".'
      },
      {
        type: 'heading',
        text: '2. Sollicitez des feedbacks'
      },
      {
        type: 'paragraph',
        text: 'Demandez à vos collègues, clients internes et managers des retours sur votre travail. Ces témoignages renforceront votre dossier et vous donneront une vision objective de vos points forts. Profitez-en aussi pour identifier les axes d\'amélioration et montrer que vous êtes proactif dans votre développement.'
      },
      {
        type: 'heading',
        text: '3. Rendez-vous visible'
      },
      {
        type: 'paragraph',
        text: 'Une promotion ne se gagne pas uniquement sur les résultats, mais aussi sur la perception. Participez activement aux réunions, proposez des idées, portez-vous volontaire pour des projets transversaux. Assurez-vous que les décideurs connaissent votre contribution et votre potentiel.'
      },
      {
        type: 'heading',
        text: '4. Préparez votre entretien'
      },
      {
        type: 'paragraph',
        text: 'Ne laissez rien au hasard. Préparez un argumentaire solide, anticipez les objections possibles et définissez clairement ce que vous demandez. Soyez précis sur le poste visé, les responsabilités souhaitées et, le cas échéant, la rémunération attendue.'
      },
      {
        type: 'conclusion',
        text: 'Une promotion se prépare plusieurs mois à l\'avance. En appliquant ces quatre actions dès maintenant, vous maximisez vos chances de commencer la nouvelle année avec de nouvelles responsabilités.'
      }
    ]
  },
  {
    id: 2,
    slug: 'negocier-augmentation-salariale',
    title: 'Négocier une augmentation salariale avec assurance',
    excerpt: 'Apprenez les techniques de négociation qui font la différence pour obtenir la rémunération que vous méritez.',
    image: 'https://images.unsplash.com/photo-1622675363311-3e1904dc1885?w=800&h=450&fit=crop',
    category: 'Rémunération',
    readTime: '4 min',
    date: '10 décembre 2025',
    author: 'Thomas Weber',
    authorRole: 'Directeur Recrutement',
    content: [
      {
        type: 'intro',
        text: 'Demander une augmentation est un exercice délicat qui génère souvent du stress. Pourtant, avec une bonne préparation et les bonnes techniques, vous pouvez aborder cette conversation avec confiance et obtenir ce que vous méritez.'
      },
      {
        type: 'heading',
        text: 'Connaissez votre valeur sur le marché'
      },
      {
        type: 'paragraph',
        text: 'Avant toute négociation, renseignez-vous sur les salaires pratiqués pour votre poste dans votre secteur et votre région. Consultez notre étude de rémunération, les offres d\'emploi similaires et votre réseau professionnel. Cette connaissance vous donnera des arguments solides et vous évitera de demander trop peu... ou trop.'
      },
      {
        type: 'heading',
        text: 'Choisissez le bon moment'
      },
      {
        type: 'paragraph',
        text: 'Le timing est crucial. Privilégiez les périodes où votre manager est disponible et de bonne humeur, après un succès notable ou lors des entretiens annuels. Évitez les moments de tension, les périodes de restructuration ou juste après une mauvaise nouvelle pour l\'entreprise.'
      },
      {
        type: 'heading',
        text: 'Préparez vos arguments'
      },
      {
        type: 'paragraph',
        text: 'Listez vos réalisations concrètes, vos responsabilités supplémentaires et votre contribution à l\'équipe. Utilisez des chiffres : projets livrés, économies réalisées, revenus générés. Montrez que vous pensez à l\'avenir : vos projets, votre engagement, votre volonté de progresser.'
      },
      {
        type: 'heading',
        text: 'Adoptez la bonne posture'
      },
      {
        type: 'paragraph',
        text: 'Restez professionnel et positif. Évitez les ultimatums ou les comparaisons avec des collègues. Exprimez votre demande clairement et laissez un silence après - c\'est souvent là que la négociation commence vraiment. Soyez prêt à écouter et à trouver un compromis si nécessaire.'
      },
      {
        type: 'conclusion',
        text: 'Une négociation salariale réussie repose sur la préparation et la confiance en soi. N\'oubliez pas : demander une augmentation est légitime si vous apportez de la valeur à votre entreprise.'
      }
    ]
  },
  {
    id: 3,
    slug: 'indices-temps-changer-poste',
    title: 'Six indices révélant qu\'il est temps de changer de poste',
    excerpt: 'Stagnation, démotivation, manque de reconnaissance... Identifiez les signaux qui indiquent qu\'un changement s\'impose.',
    image: 'https://images.unsplash.com/photo-1753162660466-8ccf98d5c04c?w=800&h=450&fit=crop&crop=faces',
    category: 'Transition',
    readTime: '6 min',
    date: '5 décembre 2025',
    author: 'Sophie Müller',
    authorRole: 'Consultante Carrière',
    content: [
      {
        type: 'intro',
        text: 'Rester trop longtemps dans un poste qui ne vous convient plus peut freiner votre carrière et affecter votre bien-être. Mais comment savoir s\'il est vraiment temps de partir ? Voici six signaux à prendre au sérieux.'
      },
      {
        type: 'heading',
        text: '1. Vous n\'apprenez plus rien'
      },
      {
        type: 'paragraph',
        text: 'Si vous faites les mêmes tâches depuis des mois sans nouveaux défis ni apprentissages, c\'est un signe de stagnation. Le développement professionnel est essentiel pour rester employable et épanoui. Si votre entreprise ne vous offre pas d\'opportunités de croissance, il est peut-être temps de les chercher ailleurs.'
      },
      {
        type: 'heading',
        text: '2. Vos valeurs ne sont plus alignées'
      },
      {
        type: 'paragraph',
        text: 'L\'entreprise a changé de direction, de culture ou de pratiques qui ne correspondent plus à vos valeurs ? Ce décalage peut créer un malaise profond. Travailler pour une organisation dont vous ne partagez pas les valeurs est épuisant à long terme.'
      },
      {
        type: 'heading',
        text: '3. Le dimanche soir est devenu anxiogène'
      },
      {
        type: 'paragraph',
        text: 'Une boule au ventre à l\'idée de retourner au travail n\'est pas normale. Si cette anxiété est récurrente et non liée à un projet ponctuel stressant, c\'est un signal d\'alarme que votre corps vous envoie.'
      },
      {
        type: 'heading',
        text: '4. Votre travail n\'est pas reconnu'
      },
      {
        type: 'paragraph',
        text: 'Malgré vos efforts et vos résultats, vous ne recevez ni reconnaissance ni promotion ? Le manque de considération chronique est démotivant et peut affecter votre estime de soi. Vous méritez d\'être valorisé pour votre contribution.'
      },
      {
        type: 'heading',
        text: '5. Les relations sont devenues toxiques'
      },
      {
        type: 'paragraph',
        text: 'Conflits permanents, management toxique, collègues négatifs... Un environnement de travail délétère impacte votre santé mentale et physique. Aucun salaire ne justifie de sacrifier votre bien-être.'
      },
      {
        type: 'heading',
        text: '6. Vous rêvez d\'autre chose'
      },
      {
        type: 'paragraph',
        text: 'Si vous passez vos journées à imaginer une autre vie professionnelle, à consulter des offres d\'emploi ou à envier les parcours des autres, c\'est que votre poste actuel ne vous satisfait plus. Écoutez cette petite voix.'
      },
      {
        type: 'conclusion',
        text: 'Si vous vous reconnaissez dans plusieurs de ces signes, il est probablement temps d\'envisager un changement. Prenez le temps de réfléchir à ce que vous voulez vraiment et préparez votre transition sereinement.'
      }
    ]
  },
  {
    id: 4,
    slug: 'erreurs-cv-pile-refus',
    title: 'Les erreurs qui condamnent votre CV à la pile des refus',
    excerpt: 'Un CV bien rédigé est votre meilleur atout. Évitez ces erreurs courantes qui peuvent vous coûter l\'entretien.',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=800&h=450&fit=crop&crop=faces',
    category: 'CV & Candidature',
    readTime: '5 min',
    date: '1 décembre 2025',
    author: 'Anne-Marie Keller',
    authorRole: 'Responsable Recrutement',
    content: [
      {
        type: 'intro',
        text: 'Les recruteurs passent en moyenne 30 secondes sur un CV. Dans ce laps de temps, certaines erreurs sont rédhibitoires et envoient directement votre candidature à la corbeille. Voici les pièges à éviter absolument.'
      },
      {
        type: 'heading',
        text: 'Les fautes d\'orthographe'
      },
      {
        type: 'paragraph',
        text: 'C\'est la première cause d\'élimination. Une seule faute peut suffire à disqualifier votre candidature, surtout pour des postes nécessitant rigueur et attention aux détails. Relisez-vous plusieurs fois et faites relire votre CV par une tierce personne.'
      },
      {
        type: 'heading',
        text: 'Un CV trop long ou mal structuré'
      },
      {
        type: 'paragraph',
        text: 'Un CV de plus de deux pages décourage la lecture. Soyez concis, allez à l\'essentiel et structurez clairement les informations. Utilisez des titres, des puces et des espaces pour faciliter la lecture rapide.'
      },
      {
        type: 'heading',
        text: 'L\'absence de personnalisation'
      },
      {
        type: 'paragraph',
        text: 'Envoyer le même CV générique à toutes les entreprises est une erreur. Adaptez votre CV à chaque offre en mettant en avant les compétences et expériences pertinentes pour le poste visé. Le recruteur doit sentir que vous avez fait l\'effort de vous intéresser à son entreprise.'
      },
      {
        type: 'heading',
        text: 'Des informations vagues'
      },
      {
        type: 'paragraph',
        text: '"Responsable de projet" ne dit rien. Préférez "Gestion d\'une équipe de 5 personnes, budget de 500K CHF, livraison en avance de 2 semaines". Les chiffres et les résultats concrets parlent plus que les descriptions de poste.'
      },
      {
        type: 'heading',
        text: 'Une photo inadaptée'
      },
      {
        type: 'paragraph',
        text: 'Si vous choisissez d\'inclure une photo, optez pour un portrait professionnel sur fond neutre. Évitez les photos de vacances, les selfies ou les images trop anciennes. En Suisse, la photo n\'est pas obligatoire mais reste courante.'
      },
      {
        type: 'heading',
        text: 'Des mensonges ou exagérations'
      },
      {
        type: 'paragraph',
        text: 'Gonfler ses compétences ou inventer des expériences est risqué. Les recruteurs vérifient les références et les incohérences se révèlent souvent en entretien. L\'honnêteté est toujours la meilleure politique.'
      },
      {
        type: 'conclusion',
        text: 'Votre CV est votre premier ambassadeur. Investissez le temps nécessaire pour le rendre impeccable et adapté à chaque candidature. C\'est un investissement qui peut changer le cours de votre carrière.'
      }
    ]
  },
  {
    id: 5,
    slug: 'reussir-entretien-visioconference',
    title: 'Comment réussir son entretien en visioconférence',
    excerpt: 'Les entretiens virtuels sont devenus la norme. Maîtrisez les codes pour faire bonne impression à distance.',
    image: 'https://images.unsplash.com/photo-1573164574511-73c773193279?w=800&h=450&fit=crop',
    category: 'Entretien',
    readTime: '4 min',
    date: '25 novembre 2025',
    author: 'Pierre Müller',
    authorRole: 'Directeur Général',
    content: [
      {
        type: 'intro',
        text: 'L\'entretien en visioconférence est devenu incontournable dans le processus de recrutement. Si les fondamentaux restent les mêmes qu\'en présentiel, ce format requiert une préparation spécifique pour éviter les faux pas techniques et faire bonne impression.'
      },
      {
        type: 'heading',
        text: 'Testez votre équipement à l\'avance'
      },
      {
        type: 'paragraph',
        text: 'Connexion internet, caméra, micro, logiciel de visioconférence... Testez tout la veille et gardez un plan B (téléphone, partage de connexion). Rien de pire que de commencer un entretien avec des problèmes techniques qui vous stressent et donnent une image d\'impréparation.'
      },
      {
        type: 'heading',
        text: 'Soignez votre environnement'
      },
      {
        type: 'paragraph',
        text: 'Choisissez un endroit calme, bien éclairé (lumière face à vous, pas derrière) et avec un arrière-plan neutre et rangé. Prévenez votre entourage pour éviter les interruptions. Un environnement professionnel renforce votre crédibilité.'
      },
      {
        type: 'heading',
        text: 'Habillez-vous comme en présentiel'
      },
      {
        type: 'paragraph',
        text: 'Même si vous êtes chez vous, adoptez une tenue professionnelle complète (oui, même le pantalon). Cela vous met dans un état d\'esprit professionnel et vous évite tout malaise si vous devez vous lever.'
      },
      {
        type: 'heading',
        text: 'Regardez la caméra'
      },
      {
        type: 'paragraph',
        text: 'Pour créer un contact visuel, regardez la caméra quand vous parlez, pas l\'écran ou votre propre image. Positionnez la fenêtre de l\'interlocuteur près de votre caméra pour que votre regard semble naturel.'
      },
      {
        type: 'heading',
        text: 'Adaptez votre communication'
      },
      {
        type: 'paragraph',
        text: 'Parlez un peu plus lentement et articulez bien. Les légers décalages de connexion peuvent hacher la conversation. Laissez des pauses pour permettre à l\'interlocuteur de réagir et éviter de vous couper mutuellement.'
      },
      {
        type: 'conclusion',
        text: 'L\'entretien en visioconférence demande une préparation technique supplémentaire, mais les règles de fond restent les mêmes : préparez vos réponses, renseignez-vous sur l\'entreprise et montrez votre motivation.'
      }
    ]
  },
  {
    id: 6,
    slug: 'developper-reseau-professionnel-suisse',
    title: 'Développer son réseau professionnel en Suisse',
    excerpt: 'Le networking reste un levier essentiel pour votre carrière. Voici nos conseils pour élargir votre réseau efficacement.',
    image: 'https://images.unsplash.com/photo-1664464683525-29b5d442af54?w=800&h=450&fit=crop',
    category: 'Networking',
    readTime: '7 min',
    date: '20 novembre 2025',
    author: 'Christine Favre',
    authorRole: 'Directrice RH',
    content: [
      {
        type: 'intro',
        text: 'En Suisse comme ailleurs, le réseau professionnel est un atout majeur pour votre carrière. On estime que 70% des postes sont pourvus via le réseau. Mais comment développer et entretenir des relations professionnelles authentiques et durables ?'
      },
      {
        type: 'heading',
        text: 'Participez aux événements professionnels'
      },
      {
        type: 'paragraph',
        text: 'Conférences, salons, afterworks, petits-déjeuners d\'affaires... La Suisse regorge d\'opportunités de networking. Repérez les événements pertinents pour votre secteur et fixez-vous l\'objectif d\'en faire au moins un par mois. Préparez un pitch de présentation concis et des cartes de visite.'
      },
      {
        type: 'heading',
        text: 'Optimisez votre présence sur LinkedIn'
      },
      {
        type: 'paragraph',
        text: 'LinkedIn est incontournable pour le networking professionnel. Complétez votre profil à 100%, publiez régulièrement du contenu pertinent, commentez les publications de votre réseau et n\'hésitez pas à envoyer des invitations personnalisées aux personnes que vous souhaitez connaître.'
      },
      {
        type: 'heading',
        text: 'Rejoignez des associations professionnelles'
      },
      {
        type: 'paragraph',
        text: 'Les associations sectorielles, clubs d\'alumni ou cercles professionnels sont d\'excellents viviers de contacts. En vous impliquant activement (bénévolat, organisation d\'événements), vous gagnez en visibilité et créez des liens plus profonds.'
      },
      {
        type: 'heading',
        text: 'Cultivez la réciprocité'
      },
      {
        type: 'paragraph',
        text: 'Le networking n\'est pas une démarche à sens unique. Réfléchissez à ce que vous pouvez apporter aux autres : une mise en relation, un conseil, une information. Être généreux crée une dynamique positive et vous rend mémorable.'
      },
      {
        type: 'heading',
        text: 'Entretenez vos contacts'
      },
      {
        type: 'paragraph',
        text: 'Un réseau non entretenu s\'étiole. Prenez régulièrement des nouvelles de vos contacts, félicitez-les pour leurs succès, partagez des articles susceptibles de les intéresser. La constance est clé pour des relations durables.'
      },
      {
        type: 'conclusion',
        text: 'Le networking est un investissement à long terme. Construisez votre réseau avant d\'en avoir besoin, avec authenticité et générosité. Les opportunités suivront naturellement.'
      }
    ]
  }
];

// Articles data for Conseils Recrutement
export const recruitmentArticles = [
  {
    id: 1,
    slug: 'recrutement-suisse-meilleurs-cabinets',
    title: 'Recrutement Suisse se distingue pour la 7ème année consécutive parmi les meilleurs cabinets',
    excerpt: 'Recrutement Suisse est honoré d\'annoncer sa 7ème reconnaissance consécutive comme l\'un des \'Meilleurs cabinets de recrutement en Suisse\'.',
    image: 'https://images.unsplash.com/photo-1573164574511-73c773193279?w=800&h=450&fit=crop',
    category: 'Actualités',
    readTime: '3 min',
    date: '12 décembre 2025',
    author: 'Pierre Müller',
    authorRole: 'Directeur Général',
    content: [
      {
        type: 'intro',
        text: 'Recrutement Suisse est fier d\'annoncer qu\'il a été reconnu pour la septième année consécutive comme l\'un des meilleurs cabinets de recrutement en Suisse. Cette distinction, basée sur une enquête approfondie auprès de candidats et d\'entreprises, confirme notre engagement envers l\'excellence.'
      },
      {
        type: 'heading',
        text: 'Une reconnaissance basée sur la satisfaction client'
      },
      {
        type: 'paragraph',
        text: 'Cette distinction repose sur une méthodologie rigoureuse incluant des enquêtes de satisfaction auprès de milliers de candidats et d\'entreprises clientes. Les critères évalués comprennent la qualité du service, la pertinence des profils proposés, la réactivité et le professionnalisme des équipes.'
      },
      {
        type: 'heading',
        text: 'L\'excellence au cœur de notre ADN'
      },
      {
        type: 'paragraph',
        text: 'Depuis plus de 25 ans, Recrutement Suisse s\'engage à offrir un service de la plus haute qualité. Cette reconnaissance récompense le travail de nos 50 consultants experts qui, chaque jour, accompagnent candidats et entreprises dans leurs projets les plus ambitieux.'
      },
      {
        type: 'heading',
        text: 'Nos engagements pour l\'avenir'
      },
      {
        type: 'paragraph',
        text: 'Cette distinction nous encourage à poursuivre nos efforts d\'innovation et d\'amélioration continue. Nous investissons dans les nouvelles technologies, la formation de nos équipes et l\'expansion de nos services pour rester le partenaire de référence en recrutement spécialisé en Suisse.'
      },
      {
        type: 'conclusion',
        text: 'Nous remercions nos clients et candidats pour leur confiance renouvelée. Cette reconnaissance est avant tout la vôtre.'
      }
    ]
  },
  {
    id: 2,
    slug: 'resilience-vs-cv-parfaits',
    title: 'Les recruteurs privilégient la résilience aux CV parfaits',
    excerpt: 'D\'après notre étude, 78% des employeurs considèrent la résilience plus importante que les compétences techniques.',
    image: 'https://images.unsplash.com/photo-1758518730384-be3d205838e8?w=800&h=450&fit=crop',
    category: 'Tendances',
    readTime: '5 min',
    date: '8 décembre 2025',
    author: 'Sophie Dubois',
    authorRole: 'Directrice Études',
    content: [
      {
        type: 'intro',
        text: 'Dans un monde professionnel en constante évolution, les compétences techniques deviennent rapidement obsolètes. Notre dernière étude révèle un changement de paradigme : les employeurs suisses valorisent désormais davantage la résilience et l\'adaptabilité que le parcours académique parfait.'
      },
      {
        type: 'heading',
        text: 'Les chiffres clés de l\'étude'
      },
      {
        type: 'paragraph',
        text: 'Sur les 500 décideurs RH interrogés en Suisse, 78% déclarent que la capacité à rebondir face aux difficultés est devenue un critère de sélection prioritaire. 65% affirment avoir déjà privilégié un candidat au parcours atypique mais résilient à un profil "classique" sur le papier.'
      },
      {
        type: 'heading',
        text: 'Pourquoi ce changement ?'
      },
      {
        type: 'paragraph',
        text: 'La pandémie, la transformation digitale et l\'incertitude économique ont démontré l\'importance de l\'adaptabilité. Les entreprises ont besoin de collaborateurs capables de naviguer dans l\'ambiguïté, d\'apprendre en continu et de rester performants sous pression.'
      },
      {
        type: 'heading',
        text: 'Comment évaluer la résilience en entretien ?'
      },
      {
        type: 'paragraph',
        text: 'Les recruteurs utilisent des questions comportementales : "Parlez-moi d\'un échec professionnel et comment vous l\'avez surmonté", "Comment avez-vous géré un changement majeur dans votre carrière ?". Les parcours non linéaires ne sont plus des handicaps mais des preuves d\'adaptabilité.'
      },
      {
        type: 'heading',
        text: 'Implications pour les candidats'
      },
      {
        type: 'paragraph',
        text: 'N\'ayez plus honte de vos échecs ou de vos reconversions. Au contraire, préparez-vous à en parler positivement. Ce qui compte, c\'est ce que vous avez appris et comment vous avez rebondi. Votre capacité à vous adapter est votre meilleur atout.'
      },
      {
        type: 'conclusion',
        text: 'La résilience n\'est pas innée, elle se développe. Chaque difficulté surmontée renforce votre "muscle" d\'adaptabilité et enrichit votre profil aux yeux des recruteurs.'
      }
    ]
  },
  {
    id: 3,
    slug: 'attirer-talents-generation-z',
    title: 'Comment attirer les talents de la Génération Z',
    excerpt: 'Les attentes des jeunes talents évoluent. Découvrez comment adapter votre stratégie de recrutement.',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&h=450&fit=crop&crop=faces',
    category: 'Stratégie RH',
    readTime: '6 min',
    date: '3 décembre 2025',
    author: 'Marie Dubois',
    authorRole: 'Consultante Senior',
    content: [
      {
        type: 'intro',
        text: 'La Génération Z (nés après 1996) représente déjà 20% de la population active suisse. Ces digital natives ont des attentes différentes vis-à-vis du travail. Pour les attirer et les retenir, les entreprises doivent repenser leur proposition de valeur employeur.'
      },
      {
        type: 'heading',
        text: 'Flexibilité et équilibre vie pro/perso'
      },
      {
        type: 'paragraph',
        text: 'Pour la Gen Z, le télétravail n\'est pas un avantage mais un prérequis. Ils attendent une flexibilité réelle sur les horaires et le lieu de travail. Les entreprises rigides sur ce point perdront la guerre des talents face à des concurrents plus souples.'
      },
      {
        type: 'heading',
        text: 'Sens et impact'
      },
      {
        type: 'paragraph',
        text: 'Cette génération veut travailler pour des entreprises qui ont un impact positif sur la société et l\'environnement. Les engagements RSE doivent être authentiques et concrets. Le greenwashing est rapidement détecté et sanctionné sur les réseaux sociaux.'
      },
      {
        type: 'heading',
        text: 'Développement et progression rapide'
      },
      {
        type: 'paragraph',
        text: 'Habitués à l\'instantanéité, les Gen Z attendent des opportunités d\'évolution rapides. Proposez des parcours de carrière clairs, du mentorat, des formations régulières et des responsabilités croissantes dès les premiers mois.'
      },
      {
        type: 'heading',
        text: 'Communication transparente'
      },
      {
        type: 'paragraph',
        text: 'Fini le management top-down opaque. La Gen Z attend de la transparence sur la stratégie, les décisions et les rémunérations. Ils veulent comprendre le "pourquoi" et être impliqués dans les décisions qui les concernent.'
      },
      {
        type: 'heading',
        text: 'Digitaliser le recrutement'
      },
      {
        type: 'paragraph',
        text: 'Processus de candidature sur mobile, entretiens vidéo, présence sur TikTok et Instagram... Adaptez vos canaux et méthodes de recrutement aux habitudes digitales de cette génération.'
      },
      {
        type: 'conclusion',
        text: 'Attirer la Gen Z nécessite une transformation profonde de la culture d\'entreprise. Mais ces changements bénéficient à tous les collaborateurs et préparent votre organisation pour l\'avenir.'
      }
    ]
  },
  {
    id: 4,
    slug: 'marque-employeur-2026',
    title: 'L\'importance de la marque employeur en 2026',
    excerpt: 'Une marque employeur forte est devenue indispensable pour attirer les meilleurs talents.',
    image: 'https://images.unsplash.com/photo-1664464683525-29b5d442af54?w=800&h=450&fit=crop',
    category: 'Marque employeur',
    readTime: '7 min',
    date: '28 novembre 2025',
    author: 'Thomas Weber',
    authorRole: 'Directeur Recrutement',
    content: [
      {
        type: 'intro',
        text: 'Dans un marché de l\'emploi tendu, la marque employeur est devenue un facteur différenciant majeur. Les candidats choisissent leur employeur autant que l\'inverse. Comment construire une marque employeur attractive et authentique ?'
      },
      {
        type: 'heading',
        text: 'Qu\'est-ce que la marque employeur ?'
      },
      {
        type: 'paragraph',
        text: 'La marque employeur est l\'image que projette une entreprise en tant qu\'employeur. Elle englobe la réputation, la culture, les valeurs, l\'environnement de travail et les avantages proposés. C\'est ce qui donne envie (ou non) de postuler et de rester.'
      },
      {
        type: 'heading',
        text: 'L\'impact sur le recrutement'
      },
      {
        type: 'paragraph',
        text: 'Les études montrent qu\'une marque employeur forte réduit le coût par embauche de 50% et le turnover de 28%. Les candidats sont prêts à accepter un salaire inférieur de 10% pour rejoindre une entreprise réputée. L\'investissement est donc rapidement rentabilisé.'
      },
      {
        type: 'heading',
        text: 'Les piliers d\'une marque employeur forte'
      },
      {
        type: 'paragraph',
        text: 'Authenticité : vos promesses doivent refléter la réalité. Cohérence : le message doit être aligné sur tous les points de contact. Différenciation : identifiez ce qui vous rend unique. Engagement des collaborateurs : vos employés sont vos meilleurs ambassadeurs.'
      },
      {
        type: 'heading',
        text: 'Les actions concrètes'
      },
      {
        type: 'paragraph',
        text: 'Développez votre présence sur les réseaux sociaux avec du contenu authentique (témoignages, coulisses, événements). Soignez l\'expérience candidat à chaque étape. Encouragez les avis sur Glassdoor et Kununu. Impliquez vos collaborateurs dans la création de contenu.'
      },
      {
        type: 'conclusion',
        text: 'La marque employeur n\'est pas un projet ponctuel mais un travail de fond continu. Elle doit être portée par la direction et incarnée par tous les collaborateurs.'
      }
    ]
  },
  {
    id: 5,
    slug: 'reduire-time-to-hire',
    title: 'Réduire le time-to-hire sans sacrifier la qualité',
    excerpt: 'Optimisez votre processus de recrutement pour gagner en efficacité tout en maintenant des standards élevés.',
    image: 'https://images.unsplash.com/photo-1573164574572-cb89e39749b4?w=800&h=450&fit=crop',
    category: 'Processus',
    readTime: '5 min',
    date: '22 novembre 2025',
    author: 'Anne-Marie Keller',
    authorRole: 'Responsable Recrutement',
    content: [
      {
        type: 'intro',
        text: 'Un processus de recrutement trop long coûte cher : les meilleurs candidats acceptent d\'autres offres, la productivité souffre du poste vacant, et votre marque employeur en pâtit. Comment accélérer sans bâcler ?'
      },
      {
        type: 'heading',
        text: 'Diagnostiquez votre processus actuel'
      },
      {
        type: 'paragraph',
        text: 'Mesurez le temps de chaque étape : publication de l\'offre, tri des CV, premiers entretiens, entretiens finaux, offre, acceptation. Identifiez les goulots d\'étranglement. Souvent, les délais les plus longs sont dus aux agendas chargés des managers.'
      },
      {
        type: 'heading',
        text: 'Simplifiez les étapes'
      },
      {
        type: 'paragraph',
        text: 'Avez-vous vraiment besoin de 5 entretiens ? Chaque étape doit avoir un objectif clair et apporter une information nouvelle. Combinez les entretiens quand c\'est possible (panel interview) et éliminez les redondances.'
      },
      {
        type: 'heading',
        text: 'Utilisez la technologie'
      },
      {
        type: 'paragraph',
        text: 'Les outils de présélection par IA, les entretiens vidéo asynchrones, les tests en ligne automatisés permettent de gagner un temps précieux sur les premières étapes. Réservez le temps humain pour l\'évaluation approfondie des finalistes.'
      },
      {
        type: 'heading',
        text: 'Impliquez les managers en amont'
      },
      {
        type: 'paragraph',
        text: 'Bloquez les créneaux d\'entretien dès le lancement du recrutement. Définissez clairement les critères de décision pour éviter les allers-retours. Donnez aux managers les moyens de décider rapidement.'
      },
      {
        type: 'heading',
        text: 'Communiquez avec les candidats'
      },
      {
        type: 'paragraph',
        text: 'Tenez les candidats informés à chaque étape. Un candidat qui sait où il en est est plus patient. À l\'inverse, le silence radio pousse les meilleurs à accepter d\'autres offres.'
      },
      {
        type: 'conclusion',
        text: 'Réduire le time-to-hire de 40% est possible sans compromettre la qualité. La clé est d\'éliminer les inefficacités, pas les étapes d\'évaluation essentielles.'
      }
    ]
  },
  {
    id: 6,
    slug: 'diversite-inclusion-quotas',
    title: 'Diversité et inclusion : au-delà des quotas',
    excerpt: 'Construire une culture d\'entreprise véritablement inclusive demande une approche holistique.',
    image: 'https://images.unsplash.com/photo-1581065178047-8ee15951ede6?w=800&h=450&fit=crop&crop=faces',
    category: 'D&I',
    readTime: '8 min',
    date: '15 novembre 2025',
    author: 'Christine Favre',
    authorRole: 'Directrice RH',
    content: [
      {
        type: 'intro',
        text: 'La diversité et l\'inclusion (D&I) sont devenues des priorités pour les entreprises suisses. Mais au-delà des déclarations d\'intention et des quotas, comment créer une culture véritablement inclusive qui libère le potentiel de chacun ?'
      },
      {
        type: 'heading',
        text: 'Diversité vs Inclusion : quelle différence ?'
      },
      {
        type: 'paragraph',
        text: 'La diversité, c\'est la composition de vos équipes (genre, origine, âge, handicap...). L\'inclusion, c\'est le sentiment d\'appartenance et la capacité de chacun à s\'exprimer et contribuer pleinement. On peut avoir de la diversité sans inclusion, et c\'est alors un échec.'
      },
      {
        type: 'heading',
        text: 'Les biais inconscients'
      },
      {
        type: 'paragraph',
        text: 'Nous avons tous des biais inconscients qui influencent nos décisions. En recrutement, cela peut conduire à favoriser des candidats qui nous ressemblent. La première étape est d\'en prendre conscience via des formations et des outils d\'évaluation objectifs.'
      },
      {
        type: 'heading',
        text: 'Repenser le recrutement'
      },
      {
        type: 'paragraph',
        text: 'Anonymisez les CV, diversifiez vos canaux de sourcing, formez vos recruteurs aux biais, utilisez des grilles d\'évaluation standardisées. Remettez en question les critères "implicites" qui excluent certains profils (école prestigieuse, parcours linéaire...).'
      },
      {
        type: 'heading',
        text: 'Créer un environnement inclusif'
      },
      {
        type: 'paragraph',
        text: 'L\'inclusion se joue au quotidien : réunions où chacun peut s\'exprimer, flexibilité pour les contraintes personnelles, tolérance zéro pour les comportements discriminatoires, célébration des différences. Le leadership doit montrer l\'exemple.'
      },
      {
        type: 'heading',
        text: 'Mesurer et ajuster'
      },
      {
        type: 'paragraph',
        text: 'Suivez des indicateurs concrets : composition des équipes, taux de promotion par groupe, enquêtes de sentiment d\'appartenance, turnover. Ces données permettent d\'identifier les problèmes et de mesurer les progrès.'
      },
      {
        type: 'conclusion',
        text: 'La D&I n\'est pas un projet RH mais une transformation culturelle qui engage toute l\'organisation. Les bénéfices sont prouvés : innovation, performance, attractivité. C\'est un investissement, pas un coût.'
      }
    ]
  }
];
